import { ExecuteFn } from '../../api';
import { logoutAction } from './simpleAuthActions';

const login = (credentials: any, api: ExecuteFn) => (dispatch: any) => {
  api({ data: credentials })
    .then(async ({ data }: any) => {
      dispatch({
        type: 'LOGIN_SUCCESS',
        accessToken: data.accessToken,
        userId: data.id,
        userName: data.name,
        userType: data.userType,
        userRoles: data.userRoles,
        permissions: data.permissions,
        advertiserId: data.advertiserId,
      });
    })
    .catch(() => {});
};

const logout = () => (dispatch: any) => {
  dispatch(logoutAction);
};

const virtualLogin =
  (
    { thenCb, catchCb }: { thenCb?: () => any; catchCb?: () => void },
    api: ExecuteFn,
    advertiserId?: string,
  ) =>
    (dispatch: any) => {
      api({ data: { advertiserId } })
        .then(async ({ data }: any) => {
          dispatch({
            type: 'SET_ADVERTISER',
            advertiserId: data.advertiserId,
            permissions: data.permissions,
            role: data.role,
          });
          thenCb?.();
        })
        .catch(() => {
          catchCb?.();
        });
    };

const virtualLogout =
  ({ thenCb }: { thenCb?: () => any }) =>
    (dispatch: any) => {
      dispatch({
        type: 'UNSET_ADVERTISER',
        advertiserId: null,
        permissions: null,
        role: null,
      });
      thenCb?.();
    };

export { login, logout, virtualLogin, virtualLogout };
